<template>
    <div class="bg-gray-850/90 backdrop-blur-lg w-[264px] rounded-2xl p-4">
        <ul class="space-y-2">
            <template v-for="(userItem, userIndex) in handleUserMenuItems">
                <li
                    class="text-brand-100 transition-all hover:bg-brand-transparent-10 rounded-lg cursor-pointer"
                    :class="{ 'text-red-200 hover:bg-red-400 hover:bg-opacity-20': userItem.slug === 'logout' }"
                    @click="handleUserItemClick(userItem)"
                >
                    <NuxtLinkLocale :to="userItem.link" class="flex justify-between items-center">
                        <div class="flex items-center space-x-2 p-2">
                            <Icon :name="(userItem.icon as string)" size="24px" />
                            <p class="text-body-sm">{{ userItem.title }}</p>
                        </div>
                        <div
                            v-if="userItem.slug === 'members'"
                            class="bg-orange-400 rounded-full px-2 py-1 text-body-sm text-gray-100"
                        >
                            {{ $t("global_new") }}
                        </div>
                    </NuxtLinkLocale>
                </li>
            </template>
        </ul>
    </div>
</template>

<script setup lang="ts">
import { useHeaderData } from "~/data/header";
import { useLayoutDialog } from "~/store/components/layout-dialog.store";
import { useUserStore } from "~/store/global/user.store";
import type { IHeaderUserMenuItem } from "~/types/components/header.type";

const { userMenuItems } = useHeaderData();

const { openDialog } = useLayoutDialog();

const userStore = useUserStore();
const subAccountSlugs = ref(["generated-photos", "account", "logout"]);

const handleUserMenuItems = computed(() => {
    const isEnterprise = userStore.userData.roles.includes("enterprise-user");
    return userStore.userData.domain === "subaccount"
        ? userMenuItems.filter((x) => subAccountSlugs.value.includes(x.slug))
        : isEnterprise
        ? userMenuItems
        : userMenuItems.filter((x) => x.slug !== "api" && x.slug !== "members");
});

const { t } = useI18n();
const isMobileMenuOpen = useMobileMenuOpen();

const emits = defineEmits(["selectItem"]);
const handleUserItemClick = (item: IHeaderUserMenuItem) => {
    emits("selectItem");
    if (item.slug !== "logout") return;
    isMobileMenuOpen.value = false;
    openDialog({
        title: t("components_header_logout"),
        titleIcon: "tabler:alert-circle",
        component: shallowRef(
            defineAsyncComponent({
                loader: () => import("~/features/authentication/components/logout/AppLogout.vue"),
            })
        ),
    });
};
</script>
